// export const BASE_URL = 'http://localhost:5000/api';
// export const BASE_URL = 'http://91.134.71.79:5000/api';
export const BASE_URL = 'https://admin.holidaybooking.be/api';

export const BYPASS_AUTH = 'true';

/** Base URL for static uploads (e.g. logos). Strips /api from BASE_URL. */
export const UPLOAD_BASE_URL =
  (typeof BASE_URL === 'string' ? BASE_URL.replace(/\/api\/?$/, '') : '') ||
  'http://localhost:5000';
